/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import { LogLevel } from "@azure/msal-browser";

/**
 * Configuration object to be passed to MSAL instance on creation. 
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md 
 */

window.backendParameters = {
    "COU": {
      "AzureAd": {
          "Instance": "https://login.microsoftonline.com/",
          "Domain": "cousa.com",
          "TenantId": "55c0c77d-3328-4ae3-8509-7d99f9dfa0ea",
          "ClientId": "b11df627-5657-42ce-99ed-c560359420ea",
          "CallbackPath": "/signin-oidc",
          "SignedOutCallbackPath ": "/signout-callback-oidc",
      
          // To call an API
          // "ClientSecret": "mULBPDg-m~~2r~503Q5jTYW3iHb.ZM1Lc_"
        },
      "Logging": {
        "LogLevel": {
          "Default": "Information",
          "Microsoft": "Warning",
          "Microsoft.Hosting.Lifetime": "Information"
        }
      },
      "xHalcon.Api": {
        "UserScope": "api://60711062-36bc-4cfe-a50e-21bb8a3b5f87/access_as_user"
      },
      "DefaultScope": "api://60711062-36bc-4cfe-a50e-21bb8a3b5f87/access_as_user",
      "Backend": {    
        "COUCOPALHA": {
          "Url": "https://copalhabackend.evolution.com.uy",
          "Port": "6042",
          "Scope": "api://5b9fa850-667c-478c-b299-0b5d03285e79/access_as_user"
        },
        "localCOPALHA": {
          "Url": "https://localhost",
          "Port": "44306",
          "Scope": "api://5b9fa850-667c-478c-b299-0b5d03285e79/access_as_user"
        },      
        "COUHALCON": {
          "Url": "https://halconbackend.evolution.com.uy",
          "Port": "6043",
          "Scope": "api://60711062-36bc-4cfe-a50e-21bb8a3b5f87/access_as_user"
        },
        "localHALCON": {
          "Url": "https://localhost",
          "Port": "44350",
          "Scope": "api://60711062-36bc-4cfe-a50e-21bb8a3b5f87/access_as_user"
        },      
        "COUTUCAN": {
            "Url": "https://tucanbackend.evolution.com.uy",
            "Port": "6044",
            "Scope": "api://732c81c4-1337-4b53-a032-152f233bb4d6/access_as_user"
        },
        "DUKE": {
            "Url": "https://dukebackend.evolution.com.uy",
            "Port": "6045",
            "Scope": "api://965150a4-7e39-439b-8cc0-d1af9bb0f8cf/access_as_user"
        },
        "localTUCAN": {
          "Url": "https://localhost",
          "Port": "44351",
          "Scope": "api://732c81c4-1337-4b53-a032-152f233bb4d6/access_as_user"
        },
        "COPALHA": {
          "Url": "https://coucopalha.azurewebsites.net",
          "Port": "443",
          "Scope": "api://5b9fa850-667c-478c-b299-0b5d03285e79/access_as_user"
        },
        "HALCON": {
          "Url": "https://couhalcon.azurewebsites.net",
          "Port": "443",
          "Scope": "api://60711062-36bc-4cfe-a50e-21bb8a3b5f87/access_as_user"
        },
        "TUCAN": {
          "Url": "https://coutucan.azurewebsites.net",
          "Port": "443",
          "Scope": "api://732c81c4-1337-4b53-a032-152f233bb4d6/access_as_user"
        }
      },
      "AllowedHosts": "*"
    },
    "EVO": {
      "AzureAd": {
          "Instance": "https://login.microsoftonline.com/",
          "Domain": "evolution.com.uy",
          "TenantId": "57a12fde-984f-4002-96f8-7c2c06d517f9",
          "ClientId": "23bd5679-f680-47cc-a14c-f150d17b4c3e",
          "CallbackPath": "/signin-oidc",
          "SignedOutCallbackPath ": "/signout-callback-oidc",
          //"ClientSecret": "NBy8Q~LzS1Pc6wo6MuOkIMsBRpZyzWdp3oOOeaQZ"
        },
        "Logging": {
          "LogLevel": {
            "Default": "Information",
            "Microsoft": "Warning",
            "Microsoft.Hosting.Lifetime": "Information"
          }
        },
        "Backend": {    
          "ERP": {
            "Url": "https://evoerp.azurewebsites.net",
            "Port": "443",
            "Scope": "api://9caae7f6-d130-441a-9e85-3498ed4c0b4e/access_as_user"
          },
          "localERP": {
            "Url": "https://localhost",
            "Port": "9002",
            "Scope": "api://9caae7f6-d130-441a-9e85-3498ed4c0b4e/access_as_user"
          },      
          "HALCON": {
            "Url": "https://evohalcon.azurewebsites.net",
            "Port": "443",
            "Scope": "api://cb9a2139-5282-46f7-981a-24a167f528c3/access_as_user"
          },
          "TUCAN": {
            "Url": "https://evotucan.azurewebsites.net",
            "Port": "443",
            "Scope": "api://b420a317-ae3e-4b62-9591-1b656631fd26/access_as_user"
          },
          "localHALCON": {
            "Url": "https://localhost",
            "Port": "44350",
            "Scope": "api://cb9a2139-5282-46f7-981a-24a167f528c3/access_as_user"
          },
          "localTUCAN": {
            "Url": "https://localhost",
            "Port": "44351",
            "Scope": "api://b420a317-ae3e-4b62-9591-1b656631fd26/access_as_user"
          },
          "localALAN": {
            "Url": "https://localhost",
            "Port": "7097",
            "Scope": "api://f1495ac7-3712-4f33-aa8d-111bb14884ae/access_as_user"
          },
          "ALAN": {
            "Url": "https://alanai-b6dvguhja5beegd3.eastus-01.azurewebsites.net",
            "Port": "443",
            "Scope": "api://f1495ac7-3712-4f33-aa8d-111bb14884ae/access_as_user"
          }
          ///,      
          // "EDCupones": {
          //   "Url": "https://edcuponesbackend.evolution.com.uy",
          //   "Port": "6045",      
          //   "Scope": "api://e7663d12-ba23-42b6-8b38-0808267ee125/access_as_user"
          // },
          // "EDSAPMM": {
          //   "Url": "https://edsapmmbackend.evolution.com.uy",
          //   "Port": "6047",
          //   "Scope": "api://80af3e33-59d5-46e9-91de-8141a673df24/access_as_user"
          // },
          // "TCP": {
          //   "Url": "https://erpbackend.evolution.com.uy",
          //   "Port": "6048",
          //   "Scope": "api://293103f5-adfc-469f-be74-5a47d079a0c2/access_as_user"
          // },
          // "GLUE": {
          //   "Url": "https://gluebackend.evolution.com.uy",
          //   "Port": "6049",
          //   "Scope": "api://f6783a84-e5c7-49f6-a8c5-15523c85f8fd/access_as_user"
          // }
        },
        "AllowedHosts": "*"
      }    
    };
    
    let _searchString = window.location.search;

if (_searchString === "" && window.location.pathname === "/"){
  //Para cuando vuelve del redirect
  let _localStorageItem = localStorage.getItem(Object.keys(localStorage).filter(x => {return (x.indexOf('request.origin') !== -1 && localStorage.getItem(x).indexOf("index.html") === -1)})[0]);
  if (_localStorageItem !== null && _localStorageItem !== undefined){
    _searchString =  '?' + localStorage.getItem(Object.keys(localStorage).filter(x => {return (x.indexOf('request.origin') !== -1 && localStorage.getItem(x).indexOf("index.html") === -1)})[0]).split('?')[1];
  }else{
    _localStorageItem = sessionStorage.getItem(Object.keys(sessionStorage).filter(x => {return (x.indexOf('request.origin') !== -1 && sessionStorage.getItem(x).indexOf("index.html") === -1)})[0]);
    if (_localStorageItem !== null && _localStorageItem !== undefined){
      _searchString =  '?' + sessionStorage.getItem(Object.keys(sessionStorage).filter(x => {return (x.indexOf('request.origin') !== -1 && sessionStorage.getItem(x).indexOf("index.html") === -1)})[0]).split('?')[1];
    }else{
      _searchString = '?' + localStorage.getItem("url_search");
    }
  }
}else{
  if (_searchString === "?standalone=true"){
    window.location.search = localStorage.url_search;
  }
}

if (_searchString != ''){
  _searchString = _searchString.substring(1);
  let _params = _searchString.split('&');

  let _locationDomain = "";
  if (window.location.search.length > 0){
      if (window.location.search.substring(1).split('&').filter(x => x.indexOf('domain=') !== -1).length > 0){
          _locationDomain = window.location.search.substring(1).split('&').filter(x => x.indexOf('domain=') !== -1)[0].split("=")[1];          
      }
  }

  let _locationApplication = "";
  if (window.location.search.length > 0){
      if (window.location.search.substring(1).split('&').filter(x => x.indexOf('application=') !== -1).length > 0){
          _locationApplication = window.location.search.substring(1).split('&').filter(x => x.indexOf('application=') !== -1)[0].split("=")[1];
          
      }
  }

  if ((window.domain !== _locationDomain) || (window.application !== _locationApplication)){
    localStorage.removeItem("account_accessToken");
    localStorage.removeItem("account_expiresOn");
  }

  _params.forEach(element => {
    let _param = element.split('=');
      if (_param[0] === "application" || _param[0] === "database" || _param[0] === "domain"){
        window[_param[0]] = _param[1];
      }
  });
}else{
    //lo saco del storage de la sesión de windows
    let _localStorageItem = localStorage.getItem(Object.keys(localStorage).filter(x => {return (x.indexOf('login.request') !== -1 && localStorage.getItem(x).indexOf("index.html") === -1)})[0]);
    if (_localStorageItem !== null){
      _searchString = _localStorageItem.split('?')[1];
      let _params = _searchString.split('&');
      _params.forEach(element => {
        let _param = element.split('=');
          if (_param[0] === "application" || _param[0] === "database" || _param[0] === "domain"){
            window[_param[0]] = _param[1];
          }
      });  
    }
}

let _authority = 'https://login.microsoftonline.com/55c0c77d-3328-4ae3-8509-7d99f9dfa0ea';
let _clientId = 'b11df627-5657-42ce-99ed-c560359420ea';
let _audience = 'b11df627-5657-42ce-99ed-c560359420ea';
_authority = '';
_clientId = '';
_audience = '';
let _scope = "";
let _redirectUri = window.location.origin + '/';

if (window.domain){
  window.backendBaseUrl = window.backendParameters[window.domain].Backend[window.application].Url + ':' + window.backendParameters[window.domain].Backend[window.application].Port + '/' + window.database + '/api/';
  _authority = 'https://login.microsoftonline.com/' + window.backendParameters[window.domain].AzureAd.TenantId;
  _audience = window.backendParameters[window.domain].AzureAd.ClientId;
  _clientId = window.backendParameters[window.domain].AzureAd.ClientId;
  _scope = window.backendParameters[window.domain].Backend[window.application].Scope;
  localStorage.setItem("application_scope", window.backendParameters[window.domain].Backend[window.application].Scope);
  localStorage.setItem("url_search", _searchString);
}else{
    console.error("no tengo forma de setear lso parámetros de login");
}

export const msalConfig = {
    auth: {
        clientId: _clientId,
        authority: _authority,
        redirectUri: _redirectUri
    },
    cache: {
        cacheLocation: "localStorage", // This configures where your cache will be stored
        storeAuthStateInCookie: true, // Set this to "true" if you are having issues on IE11 or Edge 
    },
    system: {	
        loggerOptions: {	
            loggerCallback: (level, message, containsPii) => {	
                if (containsPii) {		
                    return;		
                }		
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Info:
                        console.info(message);
                        return;
                    case LogLevel.Verbose:
                        console.debug(message);
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        return;
                    default:
                        return;
                }	
            }	
        }	
    }
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit: 
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
    scopes: ["openid", "email", "profile", "offline_access", "user.read", _scope]
};

/**
 * Add here the scopes to request when obtaining an access token for MS Graph API. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
export const graphConfig = {
    graphMeEndpoint: "https://graph.microsoft.com/v1.0/me" //e.g. https://graph.microsoft.com/v1.0/me
};

